<template>
    <div>
        <v-card-text class="pa-0">
            <div v-if="loading" class="loading-wrapper">
                <Loader />
            </div>
            <canvas v-show="!loading" id="pdf-canvas"></canvas>
        </v-card-text>
    </div>
</template>
<script>
    import { appendWebSessionId } from "@/util/url"
    import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/legacy/build/pdf.mjs"

    export default {
        name: "PDFViewer",

        props: {
            pdfUrl: {
                type: String,
            },
        },

        data() {
            return {
                loading: false,
            }
        },

        mounted() {
            this.renderPdfFromUrl("pdf-canvas", this.pdfUrl)
        },

        methods: {
            async renderPdfFromUrl(elementId, pdfUrl) {
                this.loading = true
                const canvas = document.getElementById(elementId)
                GlobalWorkerOptions.workerSrc = new URL(
                    "pdfjs-dist/legacy/build/pdf.worker.mjs",
                    import.meta.url
                ).toString()

                if (!pdfUrl) {
                    return
                }

                const pdf = await getDocument({
                    url: appendWebSessionId(`${encodeURI(pdfUrl)}`),
                }).promise

                const pages = []
                for (let i = 1; i < pdf.numPages + 1; i++) {
                    pages.push(await pdf.getPage(i))
                }

                if (!pages.length) {
                    return
                }
                let width = 0
                let height = 0
                let scale = 1

                for (const page of pages) {
                    const viewPort = page.getViewport({ scale: scale })
                    width = viewPort.width
                    height += viewPort.height
                }

                canvas.width = width
                canvas.height = height

                const context = canvas.getContext("2d")
                if (!context) {
                    throw new Error("No context")
                }

                let y = 0
                for (const page of pages) {
                    const viewport = page.getViewport({ scale: 1 })
                    context.save()
                    context.scale(1, 1)
                    context.translate(0, y)

                    await page.render({
                        canvasContext: context,
                        viewport: viewport,
                    }).promise

                    y += viewport.height

                    context.restore()
                }
                this.loading = false
                this.$emit("pdf-loaded")
            },
        },
    }
</script>

<style lang="scss" scoped>
    #pdf-canvas {
        width: 100%;
        border: 0;
    }

    .loading-wrapper {
        height: 329px;
        margin-top: 130px;
    }
</style>
